module.exports = __webpack_public_path__ + "static/media/solo15.28db5ed7.JPG";